/**
 * @generated SignedSource<<2f0bc72c78bb10b6ccc8ab2ad3792f0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TVAssigneesPopover_EmployeeItem$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  readonly " $fragmentType": "TVAssigneesPopover_EmployeeItem";
};
export type TVAssigneesPopover_EmployeeItem$key = {
  readonly " $data"?: TVAssigneesPopover_EmployeeItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"TVAssigneesPopover_EmployeeItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TVAssigneesPopover_EmployeeItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Avatar_employee"
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "9460e59d36409e2331efea21096057b4";

export default node;
